import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { ButtonYellow } from "../../buttons";
import badgeIcon from "../../../assets/images/study/badge.svg";
import completionHeaderImage from "../../../assets/images/study/completion-header.svg";
import bgAzvasa from "../../../assets/svgs/bgAzvasa4.svg";
import { useCourse } from "../../../pages/course/hooks";

const useStyles = makeStyles()((theme) => ({
  container: {
    textAlign: "center",
    backgroundColor: "#f0f8ff",
    position: "relative",
    minHeight: "calc(100vh - 180px)",
    // backgroundImage: `url(${backgroundSvg})`,
    // backgroundSize: 'center',
    // backgroundPosition: 'center center',
    // backgroundRepeat: 'no-repeat',
    width: "auto",
    height: "100%",
    fontFamily: '"Quicksand", sans-serif',
  },
  header: {
    display: "flex",
    width: "100%",
    justifyContent: "start",
    alignItems: "center",
  },
  headerImage: {
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "90%",
    },
    [theme.breakpoints.up("md")]: {
      width: "90%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "70%",
    },
    [theme.breakpoints.up("xl")]: {
      width: "70%",
    },
  },
  congratulations: {
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "100%",
    },
    [theme.breakpoints.up("md")]: {
      width: "100%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "100%",
    },
    [theme.breakpoints.up("xl")]: {
      width: "100%",
    },
  },
  bgImage: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 0,
    display: "none",
    [theme.breakpoints.up("lg")]: {
      display: "block",
    },
  },
  content: {
    zIndex: 1,
    position: "relative",
    fontFamily: '"Quicksand", sans-serif!important',
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "center",
  },
  sectionContent: {
    // marginTop: '-42px',
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    // [theme.breakpoints.up('sm')]: {
    //     marginTop: '-75px',
    // },
    // [theme.breakpoints.up('md')]: {
    //     marginTop: '-55px'
    // },
    // [theme.breakpoints.up('lg')]: {
    //     marginTop: '-92px'
    // },
    // [theme.breakpoints.up('xl')]: {
    //     marginTop: '-140px'
    // },
  },
  score: {
    fontSize: "50px",
    fontWeight: "bold",
    lineHeight: 1,
    color: "#32CD32", // Green color for score
    fontFamily: '"Quicksand", sans-serif',
    [theme.breakpoints.up("md")]: {
      fontSize: "60px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "76px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "90px",
    },
  },
  quizName: {
    color: "rgba(255, 199, 0, 1)",
    fontWeight: "700",
    lineHeight: 1,
    fontFamily: '"ms sans serif", "Segoe UI", Tahoma, sans-serif',
    position: "relative",
    textShadow: `0px 4px 16px rgba(0, 0, 0, 0.11);`,
    fontSize: "32px",
    [theme.breakpoints.up("md")]: {
      fontSize: "36px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "40px",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "50px",
    },
    textShadow: `-1px -1px 0 white,
                                1px -1px 0 white,
                                -1px 1px 0 white,
                                1px 1px 0 white,
                                -2px -2px 0 white,
                                2px -2px 0 white,
                                -2px 2px 0 white,
                                2px 2px 0 white,
                                -3px -3px 0 white,
                                3px -3px 0 white,
                                -3px 3px 0 white,
                                3px 3px 0 white,
                                -4px -4px 0 white,
                                4px -4px 0 white,
                                -4px 4px 0 white,
                        4px 4px 0 white`,
  },
  completionMessage: {
    fontFamily: '"Quicksand", sans-serif',
    fontWeight: 700,
    fontSize: "30px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
  },
  actionButtonContainer: {
    position: "absolute",
    left: "50%",
    transform: "translateX(100%)",
    top: "-8px",
    [theme.breakpoints.up("lg")]: {
      top: "-5px",
      left: "52%",
    },
  },
  actionButton: {
    position: "relative!important",
    width: "300px!important",
    marginBottom: theme.spacing(2),
    transform: "none!important",
    "-webkit-transform": "none!important",
    bottom: "0!important",
    left: "0!important",
    [theme.breakpoints.down("sm")]: {
      width: "200px!important",
    },
  },
  buttonImage: {
    width: "100%",
  },
  nextSectionText: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    fontSize: "14px",
    fontWeight: 700,
    fontFamily: '"Quicksand", sans-serif',
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "18px",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "20px",
    },
  },
}));

const SectionComplete = ({ onContinue, data = {}, nextSection, course }) => {
  const { classes } = useStyles();
  const { lastSectionChapter } = useCourse();

  return (
    <Box className={classes.container}>
      <Box className={classes.bgImage}>
        <img width={"100%"} src={bgAzvasa} />
      </Box>
      <Box className={classes.content}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mr: { xs: 0, md: 6, lg: 15 },
          }}
        >
          <Grid container spacing={2} width={"80%"}>
            <Grid item xs={3} justifyContent={"start"}>
              <img className={classes.headerImage} src={badgeIcon} />
            </Grid>
            <Grid
              item
              xs={9}
              sx={{ mt: 3 }}
              flexDirection={"column"}
              display={"flex"}
              justifyContent={"start"}
            >
              <div className={classes.header}>
                <img
                  className={classes.congratulations}
                  src={completionHeaderImage}
                />
              </div>
            </Grid>
          </Grid>
        </Box>
        {/* Completion message */}
        <Box className={classes.sectionContent}>
          <Typography
            className={classes.completionMessage}
            variant="h6"
            gutterBottom
          >
            You have completed all the sessions for
          </Typography>
          <Typography sx={{ mb: 3 }} variant="h4" className={classes.quizName}>
            {data?.name || course?.courseName}
          </Typography>
        </Box>

        <Box className={classes.sectionContent}>
          <Typography variant="h5" className={classes.nextSectionText}>
            {nextSection && nextSection.name
              ? `Proceed to ${nextSection.name}`
              : "Proceed to course completion"}
          </Typography>

          <ButtonYellow onClick={onContinue} className={classes.actionButton}>
            <Typography
              sx={{
                fontWeight: "700",
                fontFamily: '"Quicksand", sans-serif',
                fontSize: { xs: "1em", md: "1.5em", lg: "2em" },
                zIndex: 2, // Ensure the text is above the glossy effect
              }}
            >
              {nextSection && nextSection.name
                ? "Continue"
                : "Complete Chapter"}
            </Typography>
          </ButtonYellow>
        </Box>
      </Box>
    </Box>
  );
};

export default SectionComplete;
